import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Button, LinkText, ShadowBox } from '@components/common';
import { TableHeading } from '@components/Typography';
import LinkButton from '@components/BookLinkButton';
import { AuthSelectors } from '@redux/AuthRedux';
import PaymentModal from './PaymentModal';
import history from '@utils/history';
import TableCell from '@components/TableCell';

function PaymentInfo(props) {
  const { user } = props;
  const { ccLast4 } = user;

  const [show, toggleModal] = useState(false);

  const handleUpdatePayment = () => {
    toggleModal(true);
  };

  const handleViewBillingHistory = () => {
    history.push('/billing-history');
  };

  return (
    <React.Fragment>
      <TableHeading mb={4}>My Payments</TableHeading>
      {ccLast4 && (
        <ShadowBox mb={4}>
          <TableCell title="Payment Method" rightText={`*${ccLast4}`} />
        </ShadowBox>
      )}

      <Box
        display={['none', 'flex']}
        flexDirection="column"
        alignItems="flex-start"
      >
        <Button
          variant="secondary"
          size="small"
          mb={4}
          onClick={handleUpdatePayment}
        >
          {ccLast4 ? 'Update Payment Method' : 'Add Payment Method'}
        </Button>
        <Button
          variant="secondary"
          size="small"
          mb={4}
          onClick={handleViewBillingHistory}
        >
          View Payment History
        </Button>
      </Box>
      <Box display={['flex', 'none']} flexDirection="column">
        <Button variant="secondary" mb={4} onClick={handleUpdatePayment}>
          {ccLast4 ? 'Update Payment Method' : 'Add Payment Method'}
        </Button>
        <LinkButton
          mb={4}
          type="button"
          title="Payment History"
          onClick={handleViewBillingHistory}
        />
      </Box>
      <PaymentModal show={show} dismiss={() => toggleModal(false)} />
    </React.Fragment>
  );
}

PaymentInfo.propTypes = {
  user: PropTypes.object,
  isPMUser: PropTypes.bool
};

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state),
  isPMUser: AuthSelectors.selectIsPMUser(state)
});

export default connect(mapStatesToProps)(PaymentInfo);
